import { apiCall } from './gqlClient';

const EQUIPMENTS_QUERY = `
  query equipments($providerId: Float, $search: String, $category: String, $limit: JSON!) {
    equipments(providerId: $providerId, search: $search, category: $category, limit: $limit)
    {
      id
			providerId
			name
			type
			description
			category
			imageId
			isHomeCompatible
			weightAdjustable
			weightMinKg
			weightMaxKg
			weightIncrementKg
			brand
			notes
      ...fragments
    }
  }`;

export const equipmentsApiCall = async ({providerId, search, category, limit}, fragments = null) => apiCall({ query: EQUIPMENTS_QUERY, variables: {providerId, search, category, limit}, fragments });

const EQUIPMENT_QUERY = `
  query equipment($id: String!) {
    equipment(id: $id)
    {
      id
			providerId
			name
			type
			description
			category
			imageId
			isHomeCompatible
			weightAdjustable
			weightMinKg
			weightMaxKg
			weightIncrementKg
			brand
			notes
      ...fragments
    }
  }`;

export const equipmentApiCall = async ({id}, fragments = null) => apiCall({ query: EQUIPMENT_QUERY, variables: {id}, fragments });

const CREATEEQUIPMENT_QUERY = `
  mutation createEquipment($input: EquipmentInput!) {
    createEquipment(input: $input)
    {
      id
			providerId
			name
			type
			description
			category
			imageId
			isHomeCompatible
			weightAdjustable
			weightMinKg
			weightMaxKg
			weightIncrementKg
			brand
			notes
      ...fragments
    }
  }`;

export const createEquipmentApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEEQUIPMENT_QUERY, variables: {input}, fragments });

const UPDATEEQUIPMENT_QUERY = `
  mutation updateEquipment($id: String!, $input: EquipmentInput!) {
    updateEquipment(id: $id, input: $input)
    {
      id
			providerId
			name
			type
			description
			category
			imageId
			isHomeCompatible
			weightAdjustable
			weightMinKg
			weightMaxKg
			weightIncrementKg
			brand
			notes
      ...fragments
    }
  }`;

export const updateEquipmentApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEEQUIPMENT_QUERY, variables: {id, input}, fragments });

const DELETEEQUIPMENT_QUERY = `
  mutation deleteEquipment($id: String!) {
    deleteEquipment(id: $id)
    {
      id
			providerId
			name
			type
			description
			category
			imageId
			isHomeCompatible
			weightAdjustable
			weightMinKg
			weightMaxKg
			weightIncrementKg
			brand
			notes
      ...fragments
    }
  }`;

export const deleteEquipmentApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEEQUIPMENT_QUERY, variables: {id}, fragments });
